import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getPriceGroups = createAsyncThunk('/getPriceGroups', async () => {
  const response = await axios.get('/GetPriceGroups');
  return response.data;
});

export const getPriceGroupDetails = createAsyncThunk(
  '/getPriceGroupDetails',
  async id => {
    const response = await axios.get(`/GetPriceGroupDetails/${id}`);
    return response.data;
  }
);

export const getTransportPrices = createAsyncThunk('/getTransportPrices', async () => {
  const response = await axios.get('/GetTransportPrices');
  return response.data;
});


export const getServicePaymentGroupTypes = createAsyncThunk(
  '/GetServicePaymentGroupTypes',
  async () => {
    const response = await axios.get('/GetServicePaymentGroupTypes');
    return response.data;
  }
);

export const getWarrantyPaymentGroupTypes = createAsyncThunk(
  '/GetWarrantyPaymentGroupTypes',
  async () => {
    const response = await axios.get('/GetWarrantyPaymentGroupTypes/');
    return response.data;
  }
);

export const setPriceGroupDetail = createAsyncThunk(
  '/setPriceGroupDetail',
  async data => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetPriceGroupDetail',
      data
    );
    return response.data;
  }
);

const priceGroupSlice = createSlice({
  name: 'priceGroup',
  initialState: {
    loading: false,
    error: '',
    priceGroups: [],
    PriceGroupDetails: [],
    response: '',
    SelectedPriceGroupCode: '',
    SelectedPriceGroupId: 0,
    ServicePaymentGroupTypes: [],
    WarrantyPaymentGroupTypes: [],
    success : false,
    TransportPrices:[]

  },
  reducers: {
    changeSelectedPriceGroupCode(state, action) {
      state.SelectedPriceGroupCode = action.payload;
    },
    changeSelectedPriceGroupId(state, action) {
      state.SelectedPriceGroupId = action.payload;
    },
    resetDescriptions(state) {
      state.priceGroups = [];
      state.PriceGroupDetails = [];
      state.SelectedPriceGroupCode = '';
      state.SelectedPriceGroupId = 0;

    }
  },
  extraReducers: {
    [getPriceGroups.pending]: state => {
      state.loading = true;
    },
    [getPriceGroups.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPriceGroups.fulfilled]: (state, action) => {
      state.priceGroups = action.payload;
      state.loading = false;
    },
    [getPriceGroupDetails.pending]: state => {
      state.loading = true;
    },
    [getPriceGroupDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getPriceGroupDetails.fulfilled]: (state, action) => {
      state.PriceGroupDetails = action.payload;
      state.loading = false;
    },
    [getServicePaymentGroupTypes.pending]: state => {
      state.loading = true;
    },
    [getServicePaymentGroupTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServicePaymentGroupTypes.fulfilled]: (state, action) => {
      state.ServicePaymentGroupTypes = action.payload;
      state.loading = false;
    },
    [getWarrantyPaymentGroupTypes.pending]: state => {
      state.loading = true;
    },
    [getWarrantyPaymentGroupTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyPaymentGroupTypes.fulfilled]: (state, action) => {
      state.WarrantyPaymentGroupTypes = action.payload;
      state.loading = false;
    },
    [setPriceGroupDetail.pending]: state => {
      state.loading = true;
    },
    [setPriceGroupDetail.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.success = false;
    },
    [setPriceGroupDetail.fulfilled]: (state, action) => {
      state.success = true;
      state.loading = false;
    },
    [getTransportPrices.pending]: state => {
      state.loading = true;
    },
    [getTransportPrices.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTransportPrices.fulfilled]: (state, action) => {
      state.TransportPrices = action.payload;
      state.loading = false;
    },
  }
});

export const priceGroupActions = priceGroupSlice.actions;

export default priceGroupSlice;
